import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Injector,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { PolymorpheusComponent } from "@tinkoff/ng-polymorpheus";

import { TUI_NUMBER_FORMAT, TuiDialogService } from "@taiga-ui/core";
import { NgxTippyProps } from "ngx-tippy-wrapper";
import { BehaviorSubject, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { filter, IntrestPageAnswer } from "src/app/core/models/answerMapModel";
import { collegeList } from "src/app/core/models/college-filter";
import {
  ddlAcceptanceRate,
  ddlPublicPrivateList,
  enrollmentTypeList,
} from "src/app/core/models/predefineArrayListModel";
import { ApiService } from "src/app/core/services/shared/api.service";
import { CheckLoginSessionService } from "src/app/core/services/shared/check-login-session.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { PredefineArrayListService } from "src/app/core/services/shared/predefine-array-list.service";
import { Searchconfig } from "virtue-form";
import { UsMapComponent } from "../../US-map/us-map/us-map.component";
import { PaymentOptionComponent } from "../payment-option/payment-option.component";
import { number } from "echarts";

@Component({
  selector: "app-top5-college-filters",
  templateUrl: "./top5-college-filters.component.html",
  styleUrls: ["./top5-college-filters.component.scss"],
  providers: [
    {
      provide: TUI_NUMBER_FORMAT,
      useValue: { decimalSeparator: ".", thousandSeparator: "," },
    },
  ],
})
export class Top5CollegeFiltersComponent implements OnInit, AfterViewInit {
  collegeList: Array<collegeList> = [];
  enrollmentTypeList: Array<enrollmentTypeList> = [];
  enrollmentType: string[] = [];
  removeStateItems = [];
  reciprocityList = [];
  rankMin: number = 1;
  rankMax: number = 250;
  Collegedistancemax: number = 100;
  isduplicateResidencyselected: boolean = false;
  isHBCUCollege: boolean = false;
  isResidencyselected: boolean = false;
  onlyNonHBCUColleges: boolean = false;
  isProgramRank: boolean = false;
  isDistance: boolean = false;

  stateModelvalue: any | undefined = [];
  publicModelvalue: any = [];
  timeout: any;
  selectstate: any;
  acceptanceRateModelValue: any = [undefined];
  residenceFilterArray: any = [];
  isInternatinalStudent: boolean = false;
  isCallApi: boolean = false;
  enrollmentTypeModelValue: any = [];
  collegeModelvalue: any = "";
  Addhoverstr: string = "";
  AddClickStr: string = "";
  checkedColleges: any = [];
  IsLoadData: boolean = false;
  filterStateList: any | undefined = [];
  filterStateListcheck: any | undefined = [];
  message: Subject<string> = new BehaviorSubject("loading :(");
  DomiclineResidency: string =
    this.predefineArray.residenceFilterArray[2].value;

  collegeSortByList: any = [];
  collegeSortBy: string = this.predefineArray.collegeSortByList[1].value;
  ddlPublicPrivateList: Array<ddlPublicPrivateList>;
  ddlAcceptanceRate: Array<ddlAcceptanceRate> | undefined = [];
  collegeType: string = "Included";

  @Input() selectedNumberOfColleges: number = 0;
  @Input() answerMap: any | undefined;
  @Input() ipedsId: string;
  @Input() deleteBy: string;
  @Input() filterCollegeItem: any = [];

  @Output() selectctedClg: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetCollege: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetSelectedCollege: EventEmitter<any> = new EventEmitter<any>();
  filterStateList1 = new BehaviorSubject<any>("");
  filterPublicPrivateList: any = [];
  filterAcceptanceRateList: any = [];
  filterPublicPrivateAnswerList: any;
  allstatelist: any = [];
  stateList: any = [];

  isSaveData: boolean = false;
  isSidebar: boolean = false;
  pocketcost: string = undefined;
  isDisabled: boolean = false;
  selectedCollegeList: any = [];
  viewMoreList: boolean = false;
  errormsg: string;

  isReciprocityState: string = "";

  filterSelected: Map<string, filter> = new Map();
  interestPageAnswerMap: Map<string, IntrestPageAnswer> = new Map();
  userQuestionUpdate = new Subject<string>();
  changeCollegeRange = new Subject<any>();
  changeCollegeDistance = new Subject<any>();
  filterReciprocitySelected: Map<string, filter> = new Map();
  tippyPropsLeft = {
    placement: "top-start",
    arrow: false,
    theme: "light",
  };
  tippyProps = {
    placement: "top",
    arrow: true,
    theme: "light",
  };
  public baseProps: NgxTippyProps = {
    arrow: true,
    theme: "light",
  };

  ddlStateListSetting = {
    singleSelection: false,
    idField: "id",
    textField: "label",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 0,
    // limitSelection: 5,
    allowSearchFilter: false,
    enableCheckAll: false,
  };

  ddlAcceptanceRateListSetting = {
    singleSelection: false,
    idField: "id",
    textField: "label",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    // limitSelection: 5,
    allowSearchFilter: false,
    enableCheckAll: false,
  };
  constructor(
    public apiService: ApiService,
    private predefineArray: PredefineArrayListService,
    public globalvar: GlobalVarService,
    private checkUserLogin: CheckLoginSessionService,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    this.ddlPublicPrivateList = this.predefineArray.ddlPublicPrivateList;
    this.ddlAcceptanceRate = this.predefineArray.ddlAcceptanceRate;
    this.enrollmentTypeList = this.predefineArray.enrollmentTypeList;
    // this.collegeSortByList = this.predefineArray.collegeSortByList;

    if (this.globalvar.isInternatinalStudent) {
      this.collegeSortByList =
        this.predefineArray.collegeSortByListWithoutLocation;
    } else {
      this.collegeSortByList = this.predefineArray.collegeSortByList;
    }

    this.residenceFilterArray = this.predefineArray.residenceFilterArray;

    this.userQuestionUpdate
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((val) => {
        this.setfilterSelectedValues("pocketcost", [], val);
        this.applyFilter(this.collegeType, "", "", "");
      });

    this.changeCollegeRange
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((data) => {
        if (data.type == "min") {
          //  this.rankMin = val;

          this.setfilterSelectedValues("rankMin", [], data.val.toString());
        }
        if (data.type == "max") {
          //  this.rankMax = val;
          this.setfilterSelectedValues("rankMax", [], data.val.toString());
        }

        if (Number(this.rankMin) <= Number(this.rankMax)) {
          this.getCollegeList(this.collegeType, "", "");
        }
      });
    this.changeCollegeDistance
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((data) => {
        // if (data.type == "min") {
        //   //  this.rankMin = val;

        //   this.setfilterSelectedValues("rankMin", [], data.val.toString());
        // }
        if (data.type == "collegemax") {
          //  this.rankMax = val;
          this.setfilterSelectedValues("collegemax", [], data.val.toString());
        }

        if (Number(1) <= Number(this.Collegedistancemax)) {
          this.getCollegeList(this.collegeType, "", "");
        }
      });
  }

  ngOnInit() {
    this.isInternatinalStudent = this.globalvar.isInternatinalStudent;

    if (this.globalvar.answerMap) {
      this.answerMap = this.globalvar.answerMap;
    }

    if (this.globalvar.filterSelected) {
      this.filterSelected = new Map(this.globalvar.filterSelected);
      let college = this.filterSelected.get("college");
      if (college && college.list.length > 0) {
        this.checkedColleges = college.list;
      }

      let Reciprocity = this.filterSelected.get("reciprocityStateCodes");
      if (Reciprocity && Reciprocity.list.length > 0) {
        this.reciprocityList = Reciprocity.list;
        this.globalvar.ReciprocitySelectedStateList = Reciprocity.list;
      }
      if (this.globalvar.isInternatinalStudent) {
        this.DomiclineResidency =
          this.predefineArray.residenceFilterArray[2].value;
      } else {
        let DomiclineResidenc = this.filterSelected.get("DomiclineResidency");
        if (DomiclineResidenc && DomiclineResidenc.text) {
          this.DomiclineResidency = DomiclineResidenc.text;
        }
      }

      let collegeSortBy = this.filterSelected.get("collegeSortBy");
      if (collegeSortBy) {
        this.collegeSortBy = collegeSortBy.text;

        if (this.collegeSortBy == "By_Location" && this.isInternatinalStudent) {
          this.collegeSortBy = "By_Cost";
        }
      }

      let rankMin = this.filterSelected.get("rankMin");
      if (rankMin) {
        this.rankMin = Number(rankMin.text);
      }
      let collegemax = this.filterSelected.get("collegemax");
      if (collegemax) {
        this.Collegedistancemax = Number(collegemax.text);
      }

      let rankMax = this.filterSelected.get("rankMax");
      if (rankMax) {
        this.rankMax = Number(rankMax.text);
      }
      let onlyHBCU = this.filterSelected.get("onlyHBCUColleges");
      if (onlyHBCU && onlyHBCU.text) {
        this.isHBCUCollege = onlyHBCU.text == "true" ? true : false;
      }
      let isProgramRank = this.filterSelected.get("isProgramRank");
      if (isProgramRank && isProgramRank.text) {
        this.isProgramRank = isProgramRank.text == "true" ? true : false;
      }

      let isDistance = this.filterSelected.get("isDistance");
      if (isDistance && isDistance.text) {
        this.isDistance = isDistance.text == "true" ? true : false;
      }

      let collegeType = this.filterSelected.get("collegeType");
      if (collegeType && collegeType.text) {
        this.collegeType = collegeType.text;
      } else {
        this.setInterestPageAnswer("collegeType", "", this.collegeType, "");
      }

      let pocketcost = this.filterSelected.get("pocketcost");
      if (pocketcost && pocketcost.text) {
        this.pocketcost = pocketcost.text;
      }

      let publicModelvalue = this.filterSelected.get("publicModelValue");
      if (publicModelvalue && publicModelvalue.list.length > 0) {
        this.publicModelvalue = publicModelvalue.list;
      }

      // let acceptanceRateModelValue = this.filterSelected.get("acceptanceRateModelValue");
      // if (acceptanceRateModelValue && acceptanceRateModelValue.list.length > 0) {
      //   this.acceptanceRateModelValue = acceptanceRateModelValue.list;
      // }

      let enrollmentTypeModelValue = this.filterSelected.get(
        "enrollmentTypeModelValue"
      );
      if (
        enrollmentTypeModelValue &&
        enrollmentTypeModelValue.list.length > 0
      ) {
        this.enrollmentTypeModelValue = enrollmentTypeModelValue.list;
      }
      if (this.globalvar.isInternatinalStudent) {
        this.DomiclineResidency =
          this.predefineArray.residenceFilterArray[2].value;
      } else {
        let DomiclineResidency = this.filterSelected.get("DomiclineResidency");
        if (DomiclineResidency && DomiclineResidency.text) {
          this.DomiclineResidency = DomiclineResidency.text;
        }
      }
    }
    // Ravi
    // let stateList = this.globalvar.getAllStateList.get("allState");

    // if (stateList.length > 0) {
    //   this.allstatelist = stateList;
    // }
    // if (this.globalvar.filterSelected.size > 0) {
    //   this.filterSelected = this.globalvar.filterSelected;
    //   if (this.globalvar.filterSelected.get("state")) {
    //     let listAnswerMap = [];
    //     listAnswerMap = this.globalvar.filterSelected.get("state").list;

    //     if (!this.globalvar.isInternatinalStudent) {
    //       let studentState = this.answerMap.get(6);
    //       let clear_ResidencyState = this.globalvar.filterSelected.get("clear_ResidencyState");
    //       if (!clear_ResidencyState)
    //       {
    //         if (studentState != undefined)
    //         {
    //         let obj = {
    //           id: studentState.value,
    //           label: studentState.label,
    //         };

    //         let checkStudentState = listAnswerMap.filter(
    //           (list) => list.id == obj.id
    //         );
    //         if (checkStudentState.length == 0) {
    //           listAnswerMap.push(obj);
    //         }
    //       }
    //     }
    //     }
    //     this.setStateFilterAndModelValue(listAnswerMap);
    //   }
    //   if (
    //     !this.globalvar.filterSelected.get("state") ||
    //     (this.globalvar.filterSelected.get("state") &&
    //       this.globalvar.filterSelected.get("state").list.length == 0)
    //   ) {
    //     let stateStudent = [];
    //     if (!this.globalvar.isInternatinalStudent) {
    //       const state = this.answerMap.get(6);

    //       let clear_ResidencyState = this.globalvar.filterSelected.get(
    //         "clear_ResidencyState"
    //       );

    //       if (!clear_ResidencyState) {
    //         if (state != undefined) {
    //           let obj = {
    //             id: state.value,
    //             label: state.label,
    //           };
    //           stateStudent.push(obj);
    //         }
    //       }
    //     }
    //     this.setStateFilterAndModelValue(stateStudent);
    //   }

    //   if (this.globalvar.filterSelected.get("public")) {
    //     const ar = this.globalvar.filterSelected.get("public").list;
    //     if (ar.length > 0) {
    //       this.filterPublicPrivateList = ar;
    //     }
    //   }

    //   if (this.globalvar.filterSelected.get("acceptanceRate")) {
    //     const ar = this.globalvar.filterSelected.get("acceptanceRate").list;
    //     if (ar.length > 0) {
    //       this.filterAcceptanceRateList = ar;
    //     }
    //   }
    //   if (this.globalvar.filterSelected.get("acceptanceRateModelValue")) {
    //     const ar = this.globalvar.filterSelected.get(
    //       "acceptanceRateModelValue"
    //     ).list;
    //     if (ar.length > 0) {
    //       this.acceptanceRateModelValue = ar;
    //     }
    //   }

    //   if (this.globalvar.filterSelected.get("enrollmentType")) {
    //     const ar = this.globalvar.filterSelected.get("enrollmentType").list;
    //     this.enrollmentType = ar;
    //   }
    //   if (
    //     !this.globalvar.filterSelected.get("public") ||
    //     (this.globalvar.filterSelected.get("public") &&
    //       this.globalvar.filterSelected.get("public").list.length == 0)
    //   ) {
    //     // this.filterPublicPrivateList = ["PUBLIC","PRIVATE_NON_PROFIT"];
    //     // this.publicModelvalue=[true,true];
    //     // this.setfilterSelectedValues(
    //     //   "public",
    //     //   this.filterPublicPrivateList,
    //     //   "deafultValue"
    //     // );
    //     // this.setfilterSelectedValues(
    //     //   "publicModelValue",
    //     //   this.publicModelvalue,
    //     //   "deafultValue"
    //     // );
    //   }
    // }

    let stateList = this.globalvar.getAllStateList.get("allState");

    if (stateList.length > 0) {
      this.allstatelist = stateList;
    }
    if (this.globalvar.filterSelected.size > 0) {
      this.filterSelected = this.globalvar.filterSelected;
      if (this.globalvar.filterSelected.get("state")) {
        let listAnswerMap = [];
        listAnswerMap = this.globalvar.filterSelected.get("state").list;

        if (!this.globalvar.isInternatinalStudent) {
          let studentState = this.answerMap.get(6);
          let clear_ResidencyState = this.globalvar.filterSelected.get(
            "clear_ResidencyState"
          );
          // if (!clear_ResidencyState) {
          if (studentState != undefined) {
            let obj = {
              id: studentState.value,
              label: studentState.label,
            };

            let checkStudentState = listAnswerMap.filter(
              (list) => list.id == obj.id
            );
            if (checkStudentState.length == 0) {
              listAnswerMap.push(obj);

              // Check if studentState.value matches any item in stateList
              let matchingState = stateList.find(
                (state) => state.id === studentState.value
              );

              if (matchingState) {
                // Create an array with both listAnswerMap and matchingState
                let combinedData = [...listAnswerMap, matchingState];

                // Call setStateFilterAndModelValue with the combined data
                this.setStateFilterAndModelValue(combinedData);
              }
            }
          }
          // }
        }
        this.setStateFilterAndModelValue(listAnswerMap);
      }
      if (
        !this.globalvar.filterSelected.get("state") ||
        (this.globalvar.filterSelected.get("state") &&
          this.globalvar.filterSelected.get("state").list.length == 0)
      ) {
        let stateStudent = [];
        if (!this.globalvar.isInternatinalStudent) {
          const state = this.answerMap.get(6);

          let clear_ResidencyState = this.globalvar.filterSelected.get(
            "clear_ResidencyState"
          );

          if (!clear_ResidencyState) {
            if (state != undefined) {
              let obj = {
                id: state.value,
                label: state.label,
              };
              stateStudent.push(obj);
            }
          }
        }
        this.setStateFilterAndModelValue(stateStudent);
      }

      if (this.globalvar.filterSelected.get("public")) {
        const ar = this.globalvar.filterSelected.get("public").list;
        if (ar.length > 0) {
          this.filterPublicPrivateList = ar;
        }
      }

      if (this.globalvar.filterSelected.get("acceptanceRate")) {
        const ar = this.globalvar.filterSelected.get("acceptanceRate").list;
        if (ar.length > 0) {
          this.filterAcceptanceRateList = ar;
        }
      }
      if (this.globalvar.filterSelected.get("acceptanceRateModelValue")) {
        const ar = this.globalvar.filterSelected.get(
          "acceptanceRateModelValue"
        ).list;
        if (ar.length > 0) {
          this.acceptanceRateModelValue = ar;
        }
      }

      if (this.globalvar.filterSelected.get("enrollmentType")) {
        const ar = this.globalvar.filterSelected.get("enrollmentType").list;
        this.enrollmentType = ar;
      }
      if (
        !this.globalvar.filterSelected.get("public") ||
        (this.globalvar.filterSelected.get("public") &&
          this.globalvar.filterSelected.get("public").list.length == 0)
      ) {
        // this.filterPublicPrivateList = ["PUBLIC","PRIVATE_NON_PROFIT"];
        // this.publicModelvalue=[true,true];
        // this.setfilterSelectedValues(
        //   "public",
        //   this.filterPublicPrivateList,
        //   "deafultValue"
        // );
        // this.setfilterSelectedValues(
        //   "publicModelValue",
        //   this.publicModelvalue,
        //   "deafultValue"
        // );
      }
    } else {
      if (!this.globalvar.filterSelected.get("state")) {
        this.filterStateList = [];
        let stateStudent = [];

        if (!this.globalvar.isInternatinalStudent) {
          const state = this.answerMap.get(6);
          if (state != undefined) {
            let obj = {
              id: state.value,
              label: state.label,
            };
            stateStudent.push(obj);
          }
        }
        this.setStateFilterAndModelValue(stateStudent);
      }

      if (
        !this.globalvar.filterSelected.get("public") ||
        (this.globalvar.filterSelected.get("public") &&
          this.globalvar.filterSelected.get("public").list.length == 0)
      ) {
        this.filterPublicPrivateList = ["PUBLIC", "PRIVATE_NON_PROFIT"];
        this.publicModelvalue = [true, true];
        this.setfilterSelectedValues(
          "public",
          this.filterPublicPrivateList,
          "deafultValue"
        );
        this.setfilterSelectedValues(
          "publicModelValue",
          this.publicModelvalue,
          "deafultValue"
        );
      }

      if (
        !this.globalvar.filterSelected.get("acceptanceRate") ||
        (this.globalvar.filterSelected.get("acceptanceRate") &&
          this.globalvar.filterSelected.get("acceptanceRate").list.length == 0)
      ) {
        this.filterAcceptanceRateList = ["LOW", "MEDIUM", "HIGH"];
        this.acceptanceRateModelValue = this.ddlAcceptanceRate;
        this.setfilterSelectedValues(
          "acceptanceRate",
          this.filterAcceptanceRateList,
          "deafultValue"
        );
        this.setfilterSelectedValues(
          "acceptanceRateModelValue",
          this.acceptanceRateModelValue,
          "deafultValue"
        );
      }
    }

    // Check Us Map State Items subscribe

    this.globalvar.AllcheckedUSMap.subscribe((state) => {
      // if (this.globalvar.isSubscribe == true) {
      if (state) {
        this.AllselectStateItemByCheckedUsMap(state);
      }
      // }
    });

    this.globalvar.checkedUSMap.subscribe((state) => {
      // if (this.globalvar.isSubscribe == true) {
      if (state) {
        this.selectStateItemByCheckedUsMap(state);
      }
      // }
    });

    // Uncheck Us Map State Items subscribe

    this.globalvar.unCheckedUSMap.subscribe((state) => {
      // if (this.globalvar.isSubscribe == true) {
      if (state) {
        let ind = this.stateModelvalue.findIndex(
          (item) => item.id == state.toLowerCase()
        );
        this.stateModelvalue.splice(ind, 1);
        this.selectStateItemByUnCheckedUsMap(state);
      }
      // }
    });

    //  Check Reciprocity State Items subscribe
    this.globalvar.checkedReciprocityMap.subscribe((state: string) => {
      if (state) {
        // if (this.globalvar.isSubscribe == true) {
        this.selectedRepocityStateByMapitems(state.toLowerCase());
        // }
      }
    });
    // Unchecked Reciprocity State Items subscribe
    this.globalvar.UnCheckedReciprocityMap.subscribe((state) => {
      if (state) {
        // if (this.globalvar.isSubscribe == true) {
        // let ind = this.stateModelvalue.findIndex(
        //   (item) => item.id == state.toLowerCase()
        // );
        let rsind = this.reciprocityList.indexOf(state.toLowerCase());
        // if (ind != -1) {
        //   this.stateModelvalue.splice(ind, 1);
        // }
        if (rsind != -1) {
          this.reciprocityList.splice(rsind, 1);
        }
        this.selectedStateReciprocityuncheckMapitems(state.toLowerCase());
        // }
      }
    });
    this.getCollegeList(this.collegeType, "", "");
  }

  duplicateresidency() {
    this.isduplicateResidencyselected = !this.isduplicateResidencyselected;
  }

  checkstateIsReciprocity(stateCode: string) {
    let state_code = "";
    let sc = this.answerMap.get(6);
    if (sc) {
      if (sc.value) {
        state_code = sc.value;
      }
    }

    if (state_code.toLowerCase() == stateCode.toLowerCase()) {
      // this.setfilterSelectedValues(
      //   "clear_ResidencyState",
      //   [],
      //   stateCode.toLowerCase()
      // );
    } else if (stateCode.toLowerCase() != "il") {
      let isExits = this.globalvar.ReciprocitySelectedStateList.filter(
        (ele) => ele.toLowerCase() == stateCode.toLowerCase()
      );
      if (isExits.length > 0) {
        let rsind = this.globalvar.ReciprocitySelectedStateList.indexOf(
          stateCode.toLowerCase()
        );
        if (rsind != -1) {
          this.globalvar.ReciprocitySelectedStateList.splice(rsind, 1);
          this.AddClickStr = "Reciprocity Off";
          setTimeout(() => {
            this.AddClickStr = "";
          }, 2000);
        }
        this.globalvar.subscribeReciprocityMapForUnChecked(
          stateCode.toLowerCase()
        );
      } else {
        this.AddClickStr = "Reciprocity On";
        setTimeout(() => {
          this.AddClickStr = "";
        }, 2000);
        this.reciprocityList.push(stateCode.toLowerCase());
        this.globalvar.ReciprocitySelectedStateList = this.reciprocityList;
        this.globalvar.subscribeReciprocityMapForChecked(
          stateCode.toLowerCase()
        );
      }
    }
  }

  //   ngOnDestroy() {
  //     this.globalvar.ReciprocityMapState.unsubscribe()
  // }
  changePocketCost(value: string) {
    this.userQuestionUpdate.next(value);
  }
  //setModelValue
  setStateFilterAndModelValue(stateList: any) {
    this.filterStateList = [];
    let stateModelvalue = [];

    this.allstatelist.forEach((elem) => {
      let data = stateList.findIndex((item) => item.id == elem.id);
      if (data != -1) {
        const data = {
          id: elem.id,
          label: elem.label,
        };
        this.filterStateList.push(elem.id);
        stateModelvalue.push(data as any);
      }
    });

    // this.allstatelist.sort((a, b) => a.label > b.label);

    this.allstatelist.sort((a: any, b: any) => {
      let fa = a.label.toLowerCase(),
        fb = b.label.toLowerCase();
      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
    this.stateList = this.allstatelist;
    this.stateModelvalue = stateModelvalue;
  }

  getSelectedState(state: any) {
    let selectedList = [];
    state.forEach((element) => {
      selectedList.push(this.getStateNameByCode(element));
    });
    return selectedList.toString();
  }

  changeHBCUCollege() {
    this.isHBCUCollege = !this.isHBCUCollege;
    this.setfilterSelectedValues(
      "onlyHBCUColleges",
      [],
      this.isHBCUCollege ? "true" : "false"
    );
    this.applyFilter("HBCU", "", "", "");
  }

  ngOnChanges() {
    if (
      this.filterCollegeItem.length > 0 &&
      this.filterCollegeItem[0] != undefined
    ) {
      this.setFilters(this.filterCollegeItem[0]);
    }
    if (this.globalvar.deleteBy) {
      this.deleteBy = this.globalvar.deleteBy;
    }
    if (this.ipedsId && this.deleteBy == "deleteBtn") {
      this.uncheckCheckedCollege();
      // this.selectAllCollegeForUnchecked();
    }
  }

  //  selectAllCollegeForUnchecked()
  //  {

  //   // this.collegeType = "Included";
  //   // this.setfilterSelectedValues("collegeType", [], this.collegeType);
  //   this.getCollegeList(this.collegeType, 'uncheckedAndDeleteCollege', this.ipedsId);
  //  }

  uncheckByDeletebtnClick(clg: any, data1: any) {
    this.deleteBy = "deleteBtn";
    let i = this.collegeList.indexOf(clg);
    this.collegeModelvalue[i] = false;
    let ind = this.checkedColleges.indexOf(data1);
    this.checkedColleges.splice(ind, 1);
    this.interestPageAnswerMap.delete("u" + this.ipedsId);
    this.globalvar.interestPageAnswerMap.delete("u" + this.ipedsId);
    this.setfilterSelectedValues("college", this.checkedColleges, "");
  }

  uncheckCheckedCollege() {
    const checkedColleges = this.checkedColleges.find(
      (ar1) => ar1.ipedsId == this.ipedsId
    );
    if (checkedColleges) {
      let ind = this.checkedColleges.indexOf(checkedColleges);
      this.checkedColleges.splice(ind, 1);
      this.interestPageAnswerMap.delete("u" + this.ipedsId);
      this.globalvar.interestPageAnswerMap.delete("u" + this.ipedsId);
      this.setfilterSelectedValues("college", this.checkedColleges, "");
      this.getCollegeList(this.collegeType, "", this.ipedsId);
    }
  }

  // uncheckCheckedCollege() {
  //   let collegeList = this.collegeList.find(
  //     (ar1) => ar1.ipedsId == this.ipedsId
  //   );
  //   const checkedColleges = this.checkedColleges.find(
  //     (ar1) => ar1.ipedsId == this.ipedsId
  //   );
  //   if (!collegeList && checkedColleges) {
  //     let isExits = this.interestPageAnswerMap.get("u" + this.ipedsId);

  //     if (isExits != undefined) {
  //       if (isExits.defaultValue == this.ipedsId) {
  //         let clgList = isExits.list.find((ar1) => ar1.ipedsId == this.ipedsId);

  //         this.uncheckByDeletebtnClick(clgList, checkedColleges);
  //       }
  //     }
  //   } else {
  //     if (collegeList && checkedColleges) {
  //       this.uncheckByDeletebtnClick(collegeList, checkedColleges);
  //     }
  //   }
  // }

  setEnrollmentTypeFilters(filterCollegeItem: any) {
    if (filterCollegeItem?.enrollmentType != undefined) {
      let data = this.enrollmentType.filter(
        (el) => el == filterCollegeItem?.enrollmentType
      );
      if (
        data.length == 0 &&
        (filterCollegeItem?.enrollmentType == "FOUR_YEAR_PROGRAM" ||
          filterCollegeItem?.enrollmentType == "TWO_YEAR_PROGRAM")
      ) {
        // let ddlclgType = this.enrollmentTypeList.find((ddl) => ddl.value == filterCollegeItem?.enrollmentType);
        // let ddlclgType = this.enrollmentTypeList.find((ddl) => ddl.value == 'all');
        // let index = this.enrollmentTypeList.indexOf(ddlclgType);
        // this.enrollmentTypeModelValue[index] = true;
        this.enrollmentType = [];
        // this.enrollmentType.push('all');
        this.setfilterSelectedValues(
          "enrollmentType",
          this.enrollmentType,
          "all"
        );
        // this.setfilterSelectedValues(
        //   "enrollmentTypeModelValue",
        //   this.enrollmentTypeModelValue,
        //   'all'
        // );
      }
    }
  }

  setPublicPrivateFilters(filterCollegeItem: any) {
    if (filterCollegeItem?.collegeType != undefined) {
      let data = this.filterPublicPrivateList.filter(
        (el) => el == filterCollegeItem?.collegeType
      );
      if (data.length == 0) {
        let ddlclgType = this.ddlPublicPrivateList.find(
          (ddl) => ddl.value == filterCollegeItem?.collegeType
        );
        let index = this.ddlPublicPrivateList.indexOf(ddlclgType);
        this.publicModelvalue[index] = true;
        this.filterPublicPrivateList.push(filterCollegeItem?.collegeType);

        this.setfilterSelectedValues(
          "public",
          this.filterPublicPrivateList,
          filterCollegeItem?.collegeType
        );
        this.setfilterSelectedValues(
          "publicModelValue",
          this.publicModelvalue,
          filterCollegeItem?.collegeType
        );
      }
    }
  }

  setStateselectedItems(filterCollegeItem: any) {
    if (filterCollegeItem?.stateCode != undefined) {
      let checkState = this.stateModelvalue.find(
        (element) => element.id == filterCollegeItem?.stateCode
      );
      this.collegeType = "Included";
      this.setfilterSelectedValues("collegeType", [], this.collegeType);
      if (checkState == undefined) {
        let stateCode = filterCollegeItem?.stateCode.toLowerCase();
        let state = this.stateList.find(
          (el) => el.id == stateCode.toLowerCase()
        );
        this.filterStateList.push(state.id);
        this.stateModelvalue.push(state);

        this.setfilterSelectedValues("state", this.stateModelvalue, "");
        this.setStateFilterAndModelValue(
          this.globalvar.filterSelected.get("state").list
        );

        this.checkedCollege(filterCollegeItem);
      } else {
        this.checkedCollege(filterCollegeItem);
      }
    }
  }

  selectStateItemByUnCheckedUsMap(stateCode: string) {
    if (stateCode != undefined) {
      // this.globalvar.isSubscribe = false;
      let checkState = this.stateModelvalue.find(
        (element) => element.id == stateCode.toLowerCase()
      );
      this.collegeType = "Included";
      this.setfilterSelectedValues("collegeType", [], this.collegeType);
      if (checkState == undefined) {
        this.stateModelvalue.forEach((elem) => {
          this.filterStateList = [];
          this.filterStateList.push(elem.id);
        });

        this.setfilterSelectedValues("state", this.stateModelvalue, "");
        this.setStateFilterAndModelValue(
          this.globalvar.filterSelected.get("state").list
        );
      }
    }
    if (this.globalvar.isSubscribe == true) {
      this.getCollegeList("", "", "");
      this.globalvar.isSubscribe = false;
    }
  }

  selectStateItemByCheckedUsMap(stateCode: string) {
    if (stateCode != undefined) {
      let checkState = this.stateModelvalue.find(
        (element) => element.id == stateCode.toLowerCase()
      );
      this.collegeType = "Included";
      this.setfilterSelectedValues("collegeType", [], this.collegeType);
      if (checkState == undefined) {
        let state = this.stateList.find(
          (el) => el.id == stateCode.toLowerCase()
        );
        this.filterStateList.push(state.id);
        this.stateModelvalue.push(state);
        this.setfilterSelectedValues("state", this.stateModelvalue, "");
        this.setStateFilterAndModelValue(
          this.globalvar.filterSelected.get("state").list
        );
      }
      // if (this.globalvar.isSubscribe == true) {
      this.getCollegeList("", "", "");
      this.globalvar.isSubscribe = false;
      // }
    }
    // this.globalvar.isSubscribe = false;
  }
  AllselectStateItemByCheckedUsMap(stateCode: string) {
    if (stateCode != undefined) {
      let checkState = this.stateModelvalue.find(
        (element) => element.id == stateCode.toLowerCase()
      );
      this.collegeType = "Included";
      this.setfilterSelectedValues("collegeType", [], this.collegeType);
      if (checkState == undefined) {
        let state = this.stateList.find(
          (el) => el.id == stateCode.toLowerCase()
        );
        this.filterStateList.push(state.id);
        this.stateModelvalue.push(state);
        this.setfilterSelectedValues("state", this.stateModelvalue, "");
        this.setStateFilterAndModelValue(
          this.globalvar.filterSelected.get("state").list
        );
      }
      // if (this.globalvar.isSubscribe == true) {
      this.getCollegeListAll("", "", "");
      this.globalvar.isSubscribe = false;
      // }
    }
    // this.globalvar.isSubscribe = false;
  }

  ngAfterViewInit() {
    // this.message.next('all done loading :)')
    // setTimeout(() => {
    //   this.setStateFilterAndModelValue(this.globalvar.filterSelected.get("state").list);
    // }, 1);
  }
  selectedRepocityStateByMapitems(stateCode: string) {
    if (stateCode != undefined) {
      let checkState = this.stateModelvalue.filter(
        (element) => element.id.toLowerCase() == stateCode.toLowerCase()
      );
      this.collegeType = "Included";
      this.setfilterSelectedValues("collegeType", [], this.collegeType);
      if (checkState.length > 0) {
        let arry = this.reciprocityList.filter(
          (el) => el.toLowerCase() == stateCode.toLowerCase()
        );
        if (arry.length == 0) {
          this.reciprocityList.push(stateCode.toLowerCase());
          // this.reciprocityList= [...new Set(stateCode.toLowerCase())];
          this.setfilterSelectedValues(
            "reciprocityStateCodes",
            this.reciprocityList,
            ""
          );
        }
      } else {
        let state = this.stateList.find(
          (el) => el.id.toLowerCase() == stateCode.toLowerCase()
        );

        this.filterStateList.push(state.id);
        this.stateModelvalue.push(state);
        this.setfilterSelectedValues("state", this.stateModelvalue, "");

        this.reciprocityList.push(stateCode.toLowerCase());
        this.setfilterSelectedValues(
          "reciprocityStateCodes",
          this.reciprocityList,
          ""
        );
        // this.setfilterSelectedValues("Reciprocity", this.reciprocityList, "");
        this.setStateFilterAndModelValue(
          this.globalvar.filterSelected.get("state").list
        );
      }
      if (this.globalvar.isSubscribe == true) {
        this.getCollegeList("", "", "");
        this.globalvar.isSubscribe = false;
      }
    }
  }

  selectedStateReciprocityuncheckMapitems(stateCode: string) {
    if (stateCode != undefined) {
      this.collegeType = "Included";
      this.setfilterSelectedValues("collegeType", [], this.collegeType);
      this.setfilterSelectedValues(
        "reciprocityStateCodes",
        this.reciprocityList,
        ""
      );

      this.setfilterSelectedValues("state", this.stateModelvalue, "");
      this.setStateFilterAndModelValue(
        this.globalvar.filterSelected.get("state").list
      );
    }
    if (this.globalvar.isSubscribe == true) {
      this.getCollegeList("", "", "");
      this.globalvar.isSubscribe = false;
    }
  }

  setStatesFilters(filterCollegeItem: any) {
    if (filterCollegeItem.stateCode != undefined) {
      this.setStateselectedItems(filterCollegeItem);
    }
  }

  setFilters(filterCollegeItem: any) {
    this.setEnrollmentTypeFilters(filterCollegeItem);
    this.setPublicPrivateFilters(filterCollegeItem);
    this.setStatesFilters(filterCollegeItem);
  }

  checkedCollege(filterCollegeItem: any) {
    let data = {
      collegeName: filterCollegeItem.collegeName,
      ipedsId: filterCollegeItem.ipedsId,
      stateCode: filterCollegeItem.stateCode,
    };

    this.checkedColleges.push(data);
    this.selectedCollegeList = [];
    this.checkedColleges.forEach((elem: any) => {
      let clgList = [];
      if (elem) {
        let SelectedCollege = {
          ipedsId: elem?.ipedsId,
          list: clgList,
          collegeName: elem?.collegeName,
          stateCode: elem?.stateCode.toLowerCase(),
        };
        this.selectedCollegeList.push(SelectedCollege);
      }
    });
    this.setfilterSelectedValues("college", this.checkedColleges, "");
    this.applyFilter(
      this.collegeType,
      "applyBySearchBox",
      filterCollegeItem?.ipedsId,
      this.DomiclineResidency
    );
    this.filterCollegeItem = [];
    this.resetSelectedCollege.emit();
  }

  setfilterSelectedValues(key: string, list: any, text: string) {
    let obj = {
      key: key,
      list: list,
      text: text,
    };
    this.filterSelected.set(key, obj);
    this.filterSelected = new Map(this.filterSelected);
    this.globalvar.filterSelected = this.filterSelected;
  }

  reset() {
    this.pocketcost = undefined;
    this.filterPublicPrivateAnswerList = [];

    this.Collegedistancemax = 100;
    this.DomiclineResidency = this.predefineArray.residenceFilterArray[2].value;
    this.collegeSortBy = this.predefineArray.collegeSortByList[1].value;
    this.removeStateItems = [];
    this.filterSelected.clear();
    this.globalvar.filterSelected.clear();
    this.stateModelvalue = [];
    this.publicModelvalue = [];
    this.acceptanceRateModelValue = [];
    this.filterPublicPrivateList = [];
    this.filterStateList = [];
    this.checkedColleges = [];
    this.enrollmentTypeModelValue = [];
    this.enrollmentType = [];
    this.globalvar.selectedUniversityList = [];
    this.globalvar.ReciprocitySelectedStateList = [];
    this.isProgramRank = false;
    this.isDistance = false;
    this.rankMin = 1;
    this.rankMax = 250;
    this.reciprocityList = [];
    this.resetCollege.emit();
    this.getCollegeList(this.collegeType, "", "");
  }

  getCollegeList(clgType: string, action: string, ipedsId: string) {
    this.globalvar.saveChangedDeduct = true;

    if (clgType == "Included") {
      this.isHBCUCollege = false;
      this.onlyNonHBCUColleges = false;
    }

    if (clgType == "Excluded") {
      this.isHBCUCollege = false;
      this.onlyNonHBCUColleges = true;
    }
    if (clgType == "Only") {
      this.isHBCUCollege = true;
      this.onlyNonHBCUColleges = false;
    }
    let efc = this.answerMap.get(40);

    // let act = this.answerMap.get(202);
    let gpa = "";
    let gpaScale = this.answerMap.get(266);
    let actdropdown = this.answerMap.get(32);
    let act = "";
    let sat = "";
    if (actdropdown.value == "act") {
      let scoreact = this.answerMap.get(202);
      act = scoreact.value;
    }
    if (actdropdown.value == "sat") {
      let scoresct = this.answerMap.get(201);
      sat = scoresct.value;
    }
    if (gpaScale.value == "4") {
      let gpaValue = this.answerMap.get(31);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "5") {
      // let gpaValue = this.answerMap.get(271);
      let gpaValue = this.answerMap.get(274);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "12") {
      let gpaValue = this.answerMap.get(275);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "100") {
      let gpaValue = this.answerMap.get(276);
      gpa = gpaValue.value;
    }
    let state = this.answerMap.get(6);
    let cityName = this.answerMap.get(13);
    this.IsLoadData = true;
    this.apiService
      .getPocketCostForCollegeList(
        efc != undefined ? efc.value : 0,
        act,
        sat,
        gpa,
        state != undefined ? state.value : "",
        this.filterStateList,
        this.filterPublicPrivateList,
        this.pocketcost != undefined ? this.pocketcost : "",
        this.isHBCUCollege,
        this.onlyNonHBCUColleges,
        this.enrollmentType,
        this.DomiclineResidency,
        this.filterAcceptanceRateList,
        this.reciprocityList,
        Number(this.rankMin),
        Number(this.rankMax),
        Number(this.Collegedistancemax),
        this.isProgramRank,
        this.isDistance,
        cityName != undefined ? cityName.value : ""
      )
      .then((clgList: any) => {
        if (clgList) {
          this.collegeList = [];
          this.collegeModelvalue = [];
          this.selectedCollegeList = [];
          clgList.forEach((element) => {
            element.collegeName = element.collegeName;
            // element.collegeName + " (" + element.stateCode + "), Rank: "+element?.overallCollegeRankInUS +"";
          });

          // clgList.sort((a, b) => a.collegeName > b.collegeName);

          if (this.collegeSortBy == "By_Rank") {
            let collegeData = clgList;
            let acsOrderClgRank = [];
            let notAvailableClgRank = [];

            collegeData.forEach((element) => {
              if (element?.overallCollegeRankInUS) {
                acsOrderClgRank.push(element);
              } else {
                notAvailableClgRank.push(element);
              }
            });

            acsOrderClgRank.sort((a: any, b: any) => {
              let fa = a?.overallCollegeRankInUS,
                fb = b?.overallCollegeRankInUS;
              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }

              return 0;
            });

            clgList = [...acsOrderClgRank, ...notAvailableClgRank];
          }

          if (this.collegeSortBy == "By_Location") {
            let collegeData = clgList;
            let acsOrderClgDistance = [];
            let notAvailableClgDistance = [];

            collegeData.forEach((element) => {
              if (element?.distanceFromStudentLocation) {
                acsOrderClgDistance.push(element);
              } else {
                notAvailableClgDistance.push(element);
              }
            });

            acsOrderClgDistance.sort((a: any, b: any) => {
              let fa = a?.distanceFromStudentLocation,
                fb = b?.distanceFromStudentLocation;
              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }

              return 0;
            });

            clgList = [...acsOrderClgDistance, ...notAvailableClgDistance];
          }

          if (this.collegeSortBy == "By_Alphabet_A_Z") {
            clgList.sort((a: any, b: any) => {
              let fa = a.collegeName.toLowerCase(),
                fb = b.collegeName.toLowerCase();
              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            });
          }
          if (this.collegeSortBy == "By_Alphabet_Z_A") {
            clgList.sort((a: any, b: any) => {
              let fa = a.collegeName.toLowerCase(),
                fb = b.collegeName.toLowerCase();
              if (fa > fb) {
                return -1;
              }
              if (fa < fb) {
                return 1;
              }
              return 0;
            });
          }

          this.collegeList = clgList;
          if (this.collegeList.length > 10) {
            this.viewMoreList = true;
          } else {
            this.viewMoreList = false;
          }
          this.IsLoadData = false;
          this.checkedColleges.forEach((elem) => {
            const ind = this.collegeList.findIndex(
              (ar1) => ar1.ipedsId == elem.ipedsId
            );
            const data = this.collegeList.find(
              (ar1) => ar1.ipedsId == elem.ipedsId
            );

            let collegeList = [];
            if (data) {
              const data = {
                ipedsId: elem.ipedsId,
                collegeName: elem.collegeName,
              };

              collegeList.push(data as any);
              this.collegeModelvalue[ind] = collegeList;
            }
          });

          if (action == "applyBySearchBox" && ipedsId) {
            this.setInterestPageAnswer(
              "u" + ipedsId,
              ipedsId,
              this.collegeList,
              "applyBySearchBox"
            );
          }
        }
      });
  }
  getCollegeListAll(clgType: string, action: string, ipedsId: string) {
    this.globalvar.saveChangedDeduct = true;

    if (clgType == "Included") {
      this.isHBCUCollege = false;
      this.onlyNonHBCUColleges = false;
    }

    if (clgType == "Excluded") {
      this.isHBCUCollege = false;
      this.onlyNonHBCUColleges = true;
    }
    if (clgType == "Only") {
      this.isHBCUCollege = true;
      this.onlyNonHBCUColleges = false;
    }
    let efc = this.answerMap.get(40);

    // let act = this.answerMap.get(202);
    let gpa = "";
    let gpaScale = this.answerMap.get(266);
    let actdropdown = this.answerMap.get(32);
    let act = "";
    let sat = "";
    if (actdropdown.value == "act") {
      let scoreact = this.answerMap.get(202);
      act = scoreact.value;
    }
    if (actdropdown.value == "sat") {
      let scoresct = this.answerMap.get(201);
      sat = scoresct.value;
    }
    if (gpaScale.value == "4") {
      let gpaValue = this.answerMap.get(31);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "5") {
      // let gpaValue = this.answerMap.get(271);
      let gpaValue = this.answerMap.get(274);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "12") {
      let gpaValue = this.answerMap.get(275);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "100") {
      let gpaValue = this.answerMap.get(276);
      gpa = gpaValue.value;
    }
    let state = this.answerMap.get(6);
    let cityName = this.answerMap.get(13);
    this.IsLoadData = true;
    this.apiService
      .getAllPocketCostForCollegeList(
        efc != undefined ? efc.value : 0,
        act,
        sat,
        gpa,
        state != undefined ? state.value : "",
        this.filterStateList,
        this.filterPublicPrivateList,
        this.pocketcost != undefined ? this.pocketcost : "",
        this.isHBCUCollege,
        this.onlyNonHBCUColleges,
        this.enrollmentType,
        this.DomiclineResidency,
        this.filterAcceptanceRateList,
        this.reciprocityList,
        Number(this.rankMin),
        Number(this.rankMax),
        Number(this.Collegedistancemax),
        this.isProgramRank,
        this.isDistance,
        cityName != undefined ? cityName.value : ""
      )
      .then((clgList: any) => {
        if (clgList) {
          this.collegeList = [];
          this.collegeModelvalue = [];
          this.selectedCollegeList = [];
          clgList.forEach((element) => {
            element.collegeName = element.collegeName;
            // element.collegeName + " (" + element.stateCode + "), Rank: "+element?.overallCollegeRankInUS +"";
          });

          // clgList.sort((a, b) => a.collegeName > b.collegeName);

          if (this.collegeSortBy == "By_Rank") {
            let collegeData = clgList;
            let acsOrderClgRank = [];
            let notAvailableClgRank = [];

            collegeData.forEach((element) => {
              if (element?.overallCollegeRankInUS) {
                acsOrderClgRank.push(element);
              } else {
                notAvailableClgRank.push(element);
              }
            });

            acsOrderClgRank.sort((a: any, b: any) => {
              let fa = a?.overallCollegeRankInUS,
                fb = b?.overallCollegeRankInUS;
              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }

              return 0;
            });

            clgList = [...acsOrderClgRank, ...notAvailableClgRank];
          }

          if (this.collegeSortBy == "By_Location") {
            let collegeData = clgList;
            let acsOrderClgDistance = [];
            let notAvailableClgDistance = [];

            collegeData.forEach((element) => {
              if (element?.distanceFromStudentLocation) {
                acsOrderClgDistance.push(element);
              } else {
                notAvailableClgDistance.push(element);
              }
            });

            acsOrderClgDistance.sort((a: any, b: any) => {
              let fa = a?.distanceFromStudentLocation,
                fb = b?.distanceFromStudentLocation;
              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }

              return 0;
            });

            clgList = [...acsOrderClgDistance, ...notAvailableClgDistance];
          }

          if (this.collegeSortBy == "By_Alphabet_A_Z") {
            clgList.sort((a: any, b: any) => {
              let fa = a.collegeName.toLowerCase(),
                fb = b.collegeName.toLowerCase();
              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            });
          }
          if (this.collegeSortBy == "By_Alphabet_Z_A") {
            clgList.sort((a: any, b: any) => {
              let fa = a.collegeName.toLowerCase(),
                fb = b.collegeName.toLowerCase();
              if (fa > fb) {
                return -1;
              }
              if (fa < fb) {
                return 1;
              }
              return 0;
            });
          }

          this.collegeList = clgList;
          if (this.collegeList.length > 10) {
            this.viewMoreList = true;
          } else {
            this.viewMoreList = false;
          }
          this.IsLoadData = false;
          this.checkedColleges.forEach((elem) => {
            const ind = this.collegeList.findIndex(
              (ar1) => ar1.ipedsId == elem.ipedsId
            );
            const data = this.collegeList.find(
              (ar1) => ar1.ipedsId == elem.ipedsId
            );

            let collegeList = [];
            if (data) {
              const data = {
                ipedsId: elem.ipedsId,
                collegeName: elem.collegeName,
              };

              collegeList.push(data as any);
              this.collegeModelvalue[ind] = collegeList;
            }
          });

          if (action == "applyBySearchBox" && ipedsId) {
            this.setInterestPageAnswer(
              "u" + ipedsId,
              ipedsId,
              this.collegeList,
              "applyBySearchBox"
            );
          }
        }
      });
  }

  handleInput(event: any) {
    var charCode = event.which ? event.which : event.charCode;
    var ret = charCode >= 48 && charCode <= 57;
    return ret;
  }

  getControlType(type: string) {
    if (type == "PUBLIC") {
      return "Public";
    }
    if (type == "PRIVATE_FOR_PROFIT") {
      return "Private";
      // return "Private, for-profit";
    }
    if (type == "PRIVATE_NON_PROFIT") {
      return "Private";
      // return "Private, non-profit";
    }
  }

  checkProgram(val: boolean) {
    this.isProgramRank = !this.isProgramRank;
    this.setfilterSelectedValues(
      "isProgramRank",
      [],
      this.isProgramRank ? "true" : "false"
    );
    this.getCollegeList(this.collegeType, "", "");
  }

  checkDistance(val: boolean) {
    this.isDistance = !this.isDistance;
    this.setfilterSelectedValues(
      "isDistance",
      [],
      this.isDistance ? "true" : "false"
    );
    this.getCollegeList(this.collegeType, "", "");
  }
  viewCollegeList(clg: any) {
    let arr = [];
    let arrList = JSON.stringify(clg);
    let list = JSON.parse(arrList);
    if (list.length > 0) {
      if (list.length <= 10) {
        arr = list;
      } else {
        if (this.viewMoreList == true) {
          arr = list.splice(10, list.length);
        } else {
          arr = list;
        }
      }
    }
    return arr;
  }

  // viewCollegeList() {
  //   let arr = [];
  //  // let list = this.collegeList;
  //   let arrList = JSON.stringify(this.collegeList);
  //    let list = JSON.parse(arrList);
  //   if (list.length > 0) {
  //     if (list.length > 0 && list.length <= 10) {
  //       arr = list;
  //     } else {
  //       if (this.viewMoreList == true) {
  //         arr = list.splice(0, 9);

  //         console.log(arr);
  //       } else {
  //         arr = list;
  //         console.log(arr);

  //       }
  //     }
  //   }
  //   console.log(arr);

  //   return arr;
  // }

  clickviewMoreList() {
    this.viewMoreList = !this.viewMoreList;
  }
  getStateNameByCode(stateCode: string) {
    const stateList = this.allstatelist.filter(
      (item) => item.id == stateCode.toLowerCase()
    );
    return stateList[0]["label"];
  }

  onMultiItemDeSelect(ev: any, type: string) {
    let value = "";
    if (type == "state") {
      let isExitsRemoveItems = this.removeStateItems.some(
        (element) => element == true
      );
      if (isExitsRemoveItems == false) {
        this.removeStateItems.push(ev.id);
      }
      this.filterStateList = [];
      let filterstate = [];
      this.stateModelvalue.forEach((elem: Searchconfig) => {
        const dataOp = this.stateList.find((opt) => {
          return elem.id === opt.id;
        });
        if (dataOp) {
          if (dataOp?.id) {
            value = `${dataOp?.id}`;
            this.filterStateList.push(value);
            filterstate.push(dataOp);
          }
        }
      });
      this.applyFilter(this.collegeType, "", "", "");
    }

    if (type == "acceptanceRate") {
      this.filterAcceptanceRateList = [];
      this.acceptanceRateModelValue.forEach((elem: Searchconfig) => {
        const dataOp = this.ddlAcceptanceRate.find((opt) => {
          return elem.id === opt.id;
        });
        if (dataOp) {
          if (dataOp?.id) {
            value = `${dataOp?.id}`;
            this.filterAcceptanceRateList.push(value);
          }
        }
      });
      // this.setfilterSelectedValues("acceptanceRate", this.filterAcceptanceRateList, "");
      this.applyFilter(this.collegeType, "", "", "");
    }
  }

  checkIsReciprocity(stateCode: string) {
    let state_code = "";
    let sc = this.answerMap.get(6);
    if (sc) {
      if (sc.value) {
        state_code = sc.value;
      }
    }

    if (state_code.toLowerCase() == stateCode.toLowerCase()) {
      return "homeState";
    } else if (stateCode.toLowerCase() != "il") {
      if (this.reciprocityList.length > 0) {
        let arr = this.reciprocityList.filter(
          (ele) => ele.toLowerCase() == stateCode.toLowerCase()
        );
        if (arr.length > 0) {
          return "reciprocityState";
        } else {
          return "cursor-pointer";
        }
      } else {
        return "cursor-pointer";
      }
    } else {
      return "cursor-pointer";
    }
  }

  checkhoverrepocity(stateCode: string) {
    let state_code = "";
    let sc = this.answerMap.get(6);
    if (sc) {
      if (sc.value) {
        state_code = sc.value;
      }
    }

    if (stateCode.toLowerCase() == state_code.toLowerCase()) {
      this.Addhoverstr = "Home State";
    } else if (stateCode.toLowerCase() != "il") {
      if (this.reciprocityList.length > 0) {
        let arr = this.reciprocityList.filter(
          (ele) => ele.toLowerCase() == stateCode.toLowerCase()
        );
        if (arr.length > 0) {
          this.Addhoverstr = "Reciprocity On";
          return true;
        } else {
          this.Addhoverstr = "Click to Toggle Reciprocity";
          return false;
        }
      } else {
        this.Addhoverstr = "Click to Toggle Reciprocity";
        return false;
      }
    } else {
      this.Addhoverstr =
        "No reciprocity available for " + stateCode.toUpperCase();
      return false;
    }
  }
  onMultiItemSelect(ev: any, type: string) {
    let value = "";
    if (type == "state") {
      this.filterStateList = [];
      let filterstate = [];
      this.stateModelvalue.forEach((elem: Searchconfig) => {
        const dataOp = this.stateList.find((opt) => {
          return elem.id === opt.id;
        });
        if (dataOp) {
          if (dataOp?.id) {
            value = `${dataOp?.id}`;
            this.filterStateList.push(value);
            filterstate.push(dataOp);
          }
        }
      });
      this.applyFilter(this.collegeType, "", "", "");
    }

    if (type == "acceptanceRate") {
      this.filterAcceptanceRateList = [];
      this.acceptanceRateModelValue.forEach((elem: Searchconfig) => {
        const dataOp = this.ddlAcceptanceRate.find((opt) => {
          return elem.id === opt.id;
        });
        if (dataOp) {
          if (dataOp?.id) {
            value = `${dataOp?.id}`;
            this.filterAcceptanceRateList.push(value);
          }
        }
      });

      // this.setfilterSelectedValues("acceptanceRate", this.filterAcceptanceRateList, "");
      this.applyFilter(this.collegeType, "", "", "");
    }
  }

  setInterestPageAnswer(
    index: string,
    selectedValue: string,
    list: any,
    selectedLabel: any
  ) {
    let ans = {
      defaultLabel: selectedLabel,
      defaultValue: selectedValue,
      list: list,
    };
    this.interestPageAnswerMap.set(index, ans);
    this.interestPageAnswerMap = new Map(this.interestPageAnswerMap);
    this.globalvar.interestPageAnswerMap = this.interestPageAnswerMap;
  }

  compareCollege() {
    for (let index = 0; index < this.selectedCollegeList.length; index++) {
      const element = this.selectedCollegeList[index];

      let isExitsIpedsId = this.interestPageAnswerMap.get(
        "u" + element.ipedsId
      );

      if (isExitsIpedsId != undefined) {
        if (isExitsIpedsId?.defaultValue == element.ipedsId) {
        } else {
          this.setInterestPageAnswer(
            "u" + element.ipedsId,
            element.ipedsId,
            element.list,
            "compareCollege"
          );
        }
      } else {
        this.setInterestPageAnswer(
          "u" + element.ipedsId,
          element.ipedsId,
          element.list,
          "compareCollege"
        );
      }
    }

    let obj = {
      selectedCollegeList: this.selectedCollegeList,
      answerMap: this.interestPageAnswerMap,
    };

    this.selectctedClg.emit(obj);
  }

  changePublicOption(item: any, chk: boolean, index: number) {
    if (chk) {
      let filter = this.filterPublicPrivateList.filter(
        (el) => el == item.value
      );
      if (filter.length == 0) {
        this.filterPublicPrivateList.push(item.value);
        this.publicModelvalue[index] = true;
      }
    } else {
      let i = this.filterPublicPrivateList.indexOf(item.value);
      this.filterPublicPrivateList.splice(i, 1);
      this.publicModelvalue[index] = false;
    }

    if (this.filterPublicPrivateList.length == 0) {
      this.setfilterSelectedValues("public", [], "");
    } else {
      this.setfilterSelectedValues(
        "public",
        this.filterPublicPrivateList,
        item.value
      );
    }

    this.setfilterSelectedValues(
      "publicModelValue",
      this.publicModelvalue,
      item.value
    );

    this.applyFilter(this.collegeType, "", "", "");
  }

  // changeAcceptanceRateOption(item: any, chk: boolean, index: number) {
  //   if (chk) {
  //     let filter = this.filterAcceptanceRateList.filter(
  //       (el) => el == item.value
  //     );
  //     if (filter.length == 0) {
  //       this.filterAcceptanceRateList.push(item.value);
  //       this.acceptanceRateModelValue[index] = true;
  //     }
  //   } else {
  //     let i = this.filterAcceptanceRateList.indexOf(item.value);
  //     this.filterAcceptanceRateList.splice(i, 1);
  //     this.acceptanceRateModelValue[index] = false;
  //   }

  //   if (this.filterAcceptanceRateList.length == 0) {
  //     this.setfilterSelectedValues("acceptanceRate", [], "");
  //   } else {
  //     this.setfilterSelectedValues(
  //       "acceptanceRate",
  //       this.filterAcceptanceRateList,
  //       item.value
  //     );
  //   }

  //   this.setfilterSelectedValues(
  //     "acceptanceRateModelValue",
  //     this.acceptanceRateModelValue,
  //     item.value
  //   );

  //   this.applyFilter(this.collegeType, "", "", "");
  // }

  changeAcceptanceRateOption(selectedVal: string) {
    this.filterAcceptanceRateList = [];
    if (selectedVal != "all") {
      this.filterAcceptanceRateList.push(selectedVal);
    }
    this.setfilterSelectedValues(
      "acceptanceRate",
      this.filterAcceptanceRateList,
      selectedVal
    );
    this.setfilterSelectedValues(
      "acceptanceRateModelValue",
      this.acceptanceRateModelValue,
      selectedVal
    );
    this.applyFilter(this.collegeType, "", "", "");
  }

  changeEnrollmentType(enrollmentType: string) {
    this.enrollmentType = [];
    if (enrollmentType != "all") {
      this.enrollmentType.push(enrollmentType);
    }
    this.setfilterSelectedValues(
      "enrollmentTypeModelValue",
      this.enrollmentTypeModelValue,
      enrollmentType
    );
    this.setfilterSelectedValues(
      "enrollmentType",
      this.enrollmentType,
      enrollmentType
    );
    this.applyFilter(this.collegeType, "", "", "");
  }

  // changeEnrollmentType(item: any, chk: boolean, index: number) {
  //   if (chk) {
  //     let filter = this.enrollmentType.filter((el) => el == item.value);
  //     if (filter.length == 0) {
  //       this.enrollmentType.push(item.value);
  //       this.enrollmentTypeModelValue[index] = true;
  //     }
  //   } else {
  //     let i = this.enrollmentType.indexOf(item.value);
  //     this.enrollmentType.splice(i, 1);
  //     this.enrollmentTypeModelValue[index] = false;
  //   }

  //   this.setfilterSelectedValues(
  //     "enrollmentTypeModelValue",
  //     this.enrollmentTypeModelValue,
  //     item.value
  //   );
  //   this.setfilterSelectedValues(
  //     "enrollmentType",
  //     this.enrollmentType,
  //     item.value
  //   );
  //   this.applyFilter(this.collegeType, "", "");
  // }

  // changeEnrollmentType(item: any, chk: boolean, index: number) {
  //   if (chk) {
  //     let filter = this.enrollmentType.filter((el) => el == item.value);
  //     if (filter.length == 0) {
  //       this.enrollmentType.push(item.value);
  //       this.enrollmentTypeModelValue[index] = true;
  //     }
  //   } else {
  //     let i = this.enrollmentType.indexOf(item.value);
  //     this.enrollmentType.splice(i, 1);
  //     this.enrollmentTypeModelValue[index] = false;
  //   }

  //   this.setfilterSelectedValues(
  //     "enrollmentTypeModelValue",
  //     this.enrollmentTypeModelValue,
  //     item.value
  //   );
  //   this.setfilterSelectedValues(
  //     "enrollmentType",
  //     this.enrollmentType,
  //     item.value
  //   );
  //   this.applyFilter(this.collegeType, "", "");
  // }

  applyFilter(
    clgType: string,
    action: string,
    ipedsId: string,
    Domicline: any
  ) {
    if (this.checkUserLogin.CheckUserSession() == false) {
      this.checkUserLogin.onLogout("Manual");
    } else {
      this.setfilterSelectedValues("college", this.checkedColleges, "");
      this.setfilterSelectedValues("state", this.stateModelvalue, "");
      this.setfilterSelectedValues(
        "acceptanceRate",
        this.filterAcceptanceRateList,
        ""
      );
      this.setfilterSelectedValues(
        "acceptanceRateModelValue",
        this.acceptanceRateModelValue,
        ""
      );

      this.getCollegeList(clgType, action, ipedsId);
    }
  }

  checkDisabled(value: boolean, clg: any) {
    if (this.checkedColleges.length > 0) {
      let checkedClg = this.checkedColleges.some(
        (element) => element.ipedsId == clg.ipedsId
      );
      if (this.checkedColleges.length == 25) {
        if (checkedClg == true) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  checkUncheck(type: string) {
    this.selectedCollegeList = [];
    this.checkedColleges.forEach((elem: any) => {
      let clgList = [];
      let isExitsList = this.interestPageAnswerMap.get("u" + elem?.ipedsId);
      if (isExitsList != undefined) {
        if (isExitsList.defaultValue == elem.ipedsId) {
          clgList = isExitsList.list;
        } else {
          clgList = this.collegeList;
        }
      } else {
        clgList = this.collegeList;
      }
      if (elem) {
        let SelectedCollege = {
          ipedsId: elem?.ipedsId,
          list: clgList,
          collegeName: elem?.collegeName,
          stateCode: elem?.stateCode.toLowerCase(),
        };
        this.selectedCollegeList.push(SelectedCollege);
      }
    });

    if (type != "delete") {
      this.compareCollege();
    }
    this.setfilterSelectedValues("college", this.selectedCollegeList, "");
  }

  getSelectedValue(obj: any, checkUncheck: boolean, index: string) {
    this.filterCollegeItem = {};
    let data = {
      collegeName: obj.collegeName,
      ipedsId: obj.ipedsId,
      stateCode: obj.stateCode,
    };

    if (checkUncheck) {
      this.globalvar.deleteBy = "checkedClg";
      this.deleteBy = "checkedClg";
      this.collegeModelvalue[index] = true;
      this.checkedColleges.push(data);
      this.checkUncheck("checkedclg");
    } else {
      this.globalvar.deleteBy = "unCheckedClg";
      this.deleteBy = "unCheckedClg";
      this.collegeModelvalue[index] = false;
      let arr = this.checkedColleges.find(
        (item) => item.ipedsId == data.ipedsId
      );
      let ind = this.checkedColleges.indexOf(arr);
      this.checkedColleges.splice(ind, 1);
      this.interestPageAnswerMap.delete("u" + data.ipedsId);
      this.globalvar.interestPageAnswerMap.delete("u" + data.ipedsId);

      let clgData = {
        selectedClg: arr,
        index: ind,
      };
      this.deleteRow.emit(clgData);
      this.checkUncheck("delete");
    }
  }

  changeCollege(type: string) {
    this.collegeType = type;
    this.setfilterSelectedValues("collegeType", [], type);
    this.applyFilter(type, "", "", "");
  }
  changeDomiclineResidency(data: any) {
    this.DomiclineResidency = data.target.value;
    this.setfilterSelectedValues(
      "DomiclineResidency",
      [],
      this.DomiclineResidency
    );
    this.applyFilter(this.DomiclineResidency, "", "", "");
  }

  getdomiciline(data: any) {
    this.DomiclineResidency = data;
    this.setfilterSelectedValues(
      "DomiclineResidency",
      [],
      this.DomiclineResidency
    );
    this.applyFilter(this.DomiclineResidency, "", "", "");
  }

  ChangeSorting(value: string) {
    this.collegeSortBy = value;
    this.setfilterSelectedValues("collegeSortBy", [], this.collegeSortBy);

    this.applyFilter(this.DomiclineResidency, "", "", "");

    // CollegeData.sort((a, b) => a.collegeName > b.collegeName);

    // if(value=='By Alphabet')
    // {
    //   CollegeDataList.sort((a: any, b: any) => {
    //     let fa = a.collegeName.toLowerCase(),
    //       fb = b.collegeName.toLowerCase();
    //     if (fa < fb) {
    //       return -1;
    //     }
    //     if (fa > fb) {
    //       return 1;
    //     }
    //     return 0;
    //   });
    // }

    //    this.collegeList = CollegeDataList;

    //           this.checkedColleges.forEach((elem) => {
    //             const ind = this.collegeList.findIndex(
    //               (ar1) => ar1.ipedsId == elem.ipedsId
    //             );
    //             const data = this.collegeList.find(
    //               (ar1) => ar1.ipedsId == elem.ipedsId
    //             );

    //             let collegeList = [];
    //             if (data) {
    //               const data = {
    //                 ipedsId: elem.ipedsId,
    //                 collegeName: elem.collegeName,
    //               };

    //               collegeList.push(data as any);
    //               this.collegeModelvalue[ind] = collegeList;
    //             }
    //           });
  }

  residency() {
    this.isResidencyselected = !this.isResidencyselected;
  }
  addcommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  sidebar() {
    this.isSidebar = !this.isSidebar;
  }
  func1(event: any) {
    event.stopPropagation();
  }
  private paymentoptionAdd = this.dialogService.open<any>(
    new PolymorpheusComponent(PaymentOptionComponent, this.injector),
    {
      dismissible: false,
      label: "",
      // size: "l",
    }
  );
  paymentoption() {
    this.paymentoptionAdd = this.dialogService.open<any>(
      new PolymorpheusComponent(PaymentOptionComponent, this.injector),
      {
        //  data: this.stateModelvalue,
        dismissible: false,
        // size: "l",
      }
    );
    this.paymentoptionAdd.subscribe({
      next: (data: any) => {
        this.pocketcost = data;
        this.userQuestionUpdate.next(this.pocketcost);
      },
      complete: () => {
        console.log("value");
      },
    });
  }
  clearpocketcost() {
    this.pocketcost = "";
    this.userQuestionUpdate.next(this.pocketcost);
  }

  private openStateMap = this.dialogService.open<any>(
    new PolymorpheusComponent(UsMapComponent, this.injector),
    {
      dismissible: false,
      label: "",
      // size: "l",
    }
  );

  OpenMap() {
    // this.globalvar.initialiseStateMapSubjectBehaviour();
    this.openStateMap = this.dialogService.open<any>(
      new PolymorpheusComponent(UsMapComponent, this.injector),
      {
        data: this.stateModelvalue,
        dismissible: false,
        // size: "l",
      }
    );
    this.openStateMap.subscribe({
      next: (data: any) => {},
      complete: () => {},
    });
  }
  RemoveItem(stateCode: string) {
    let state_code = "";
    let sc = this.answerMap.get(6);
    if (sc) {
      if (sc.value) {
        state_code = sc.value;
      }
    }

    if (state_code.toLowerCase() == stateCode.toLowerCase()) {
      this.setfilterSelectedValues(
        "clear_ResidencyState",
        [],
        stateCode.toLowerCase()
      );
    }

    const indexToRemove = this.filterStateList.findIndex(
      (selectedItem) => selectedItem.toLowerCase() == stateCode.toLowerCase()
    );
    if (indexToRemove !== -1) {
      this.filterStateList.splice(indexToRemove, 1);
    }

    const mdlValue = this.stateModelvalue.findIndex(
      (elem) => elem.id == stateCode.toLowerCase()
    );
    if (mdlValue != -1) {
      this.stateModelvalue.splice(mdlValue, 1);
    }
    const indexToRemoveReciprocity =
      this.globalvar.ReciprocitySelectedStateList.findIndex(
        (selectedItem) => selectedItem.toLowerCase() == stateCode.toLowerCase()
      );

    this.setfilterSelectedValues("state", this.stateModelvalue, "");
    this.setStateFilterAndModelValue(
      this.globalvar.filterSelected.get("state").list
    );
    if (indexToRemoveReciprocity != -1) {
      this.globalvar.ReciprocitySelectedStateList.splice(
        indexToRemoveReciprocity,
        1
      );
      this.globalvar.subscribeReciprocityMapForUnChecked(
        stateCode.toLowerCase()
      );
    } else {
      this.getCollegeList(this.collegeType, "", "");
    }
  }

  changeRank(val: number, type: string) {
    let data = {
      val: val,
      type: type,
    };
    this.changeCollegeRange.next(data);
    // if (type == "min") {
    // //  this.rankMin = val;

    //   this.setfilterSelectedValues("rankMin", [], val.toString());
    // }
    // if (type == "max") {
    // //  this.rankMax = val;
    //   this.setfilterSelectedValues("rankMax", [], val.toString());
    // }

    // if(Number(this.rankMin) < Number(this.rankMax))
    // {
    //   this.getCollegeList(this.collegeType, "", "");
    // }
  }
  collegeDistance(val: number, type: string) {
    let data = {
      val: val,
      type: type,
    };
    this.changeCollegeDistance.next(data);
    // if (type == "min") {
    // //  this.rankMin = val;

    //   this.setfilterSelectedValues("rankMin", [], val.toString());
    // }
    // if (type == "max") {
    // //  this.rankMax = val;
    //   this.setfilterSelectedValues("rankMax", [], val.toString());
    // }

    // if(Number(this.rankMin) < Number(this.rankMax))
    // {
    //   this.getCollegeList(this.collegeType, "", "");
    // }
  }

  numbersOnly(event: any) {
    let charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
}
